export enum FloorZoomMode {
  INITIAL = "Initial",
  ZOOMIN = "Zoomin",
  ZOOMOUT = "Zoomout",
  ROTATE = "Rotate"
}
